module.exports = __webpack_public_path__ + "static/media/openApps.dd6e6992.svg";